import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { groupValidationIssuesByTopLevelPath, } from '@dossierhq/core';
import { Column, GridList, GridListDragHandle, GridListItem, useDragAndDrop, } from '@dossierhq/design';
import { useCallback, useMemo } from 'react';
import { ValidationIssuesDisplay } from './ValidationIssuesDisplay.js';
const noErrors = [];
export function FieldListWrapper({ value, fieldSpec, adminOnly, validationIssues, onChange, AddButton, Editor, }) {
    const handleAddItem = useCallback((itemValue) => {
        if (onChange) {
            onChange(value ? [...value, itemValue] : [itemValue]);
        }
    }, [value, onChange]);
    const handleItemChange = useCallback((itemValue, index) => {
        if (onChange) {
            const newValue = value ? [...value] : [];
            if (itemValue === null || itemValue === undefined) {
                newValue.splice(index, 1);
            }
            else {
                newValue[index] = itemValue;
            }
            onChange(newValue.length > 0 ? newValue : null);
        }
    }, [value, onChange]);
    const { root: rootValidationIssues, children: indexValidationIssues } = useMemo(() => groupValidationIssuesByTopLevelPath(validationIssues), [validationIssues]);
    const { dragAndDropHooks: fieldsDragAndDropHooks } = useDragAndDrop({
        getItems: (keys) => [...keys].map((key) => ({ 'application/json': JSON.stringify(value?.[key]) })),
        onReorder: (event) => {
            if (!value || event.target.dropPosition === 'on') {
                return;
            }
            const moveIndex = [...event.keys][0];
            let targetIndex = event.target.key;
            if (moveIndex === targetIndex) {
                return;
            }
            const newValue = [...value];
            const [itemToMove] = newValue.splice(moveIndex, 1);
            if (targetIndex > moveIndex) {
                targetIndex--;
            }
            if (event.target.dropPosition === 'after') {
                newValue.splice(targetIndex + 1, 0, itemToMove);
            }
            else {
                newValue.splice(targetIndex, 0, itemToMove);
            }
            onChange(newValue);
        },
    });
    return (_jsxs(Column, { overflowY: "auto", children: [value && value.length > 0 ? (_jsx(GridList, { "aria-label": `List of values`, dragAndDropHooks: fieldsDragAndDropHooks, children: value.map((it, index) => {
                    return (_jsx(GridListItem, { id: index, className: "nested-value-item-indentation", marginVertical: 1, textValue: `Value ${index + 1}`, children: _jsx(Editor, { value: it, fieldSpec: fieldSpec, adminOnly: adminOnly, validationIssues: indexValidationIssues.get(index) ?? noErrors, dragHandle: _jsx(GridListDragHandle, {}), onChange: (newItemValue) => handleItemChange(newItemValue, index) }) }, index));
                }) })) : null, _jsx(AddButton, { fieldSpec: fieldSpec, onAddItem: handleAddItem }), _jsx(ValidationIssuesDisplay, { validationIssues: rootValidationIssues })] }));
}
//# sourceMappingURL=FieldListWrapper.js.map